import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { toast } from 'react-toastify';
import moment from 'moment';

import { Filter, Main } from '../../containers';
import { VerificationSelectionForm } from './components/VerificationSelectionForm';
import { getIsDirty } from 'Common/Selectors/DirtySelector';
import { getControlInfo } from 'State/controlInfo/actions';
import { fiscalYear } from 'State/selectors';
import {
  fetchData,
  processVerification,
  clearProcessResult,
  startOver,
} from './state/selection/actions';
import * as selector from './state/selectors';
import { VERIFICATION_SELECTION_FORM_NAME } from 'Common/FormEnum';
import { createToast, toastType } from 'Common/ToastHelper';
import { LoadingPage, YesNoDialog } from 'Components';

class VerificationSelectionContainer extends Component {
  state = {
    showYesNo: false,
  };

  componentDidMount() {
    this.props.fetchData();
    this.props.getControlInfo();
  }

  handleProcess = values => {
    toast.dismiss();
    this.props.processVerification(values);
  };

  handleStartOver = () => {
    this.setState({ showYesNo: false });
    toast.dismiss();
    this.props.startOver();
  };

  componentDidUpdate(prevProps, prevState) {
    const { result } = this.props;

    if (result && prevProps.result !== result) {
      const { isError } = result;

      createToast(
        isError ? toastType.error : toastType.success,
        'Result',
        result.message,
        !isError
      );
      this.props.clearProcessResult();

      //refresh if ok
      if (!isError) {
        this.props.fetchData();
      }
    }
  }

  componentWillUnmount() {
    //remove toasts when leaving this page
    toast.dismiss();
  }

  isStartOverEnabled = () => {
    const { data } = this.props;

    if (data && data.IsClosed) {
      return false;
    }

    if (data && data.HasBeenPrinted) {
      return false;
    }
    if (
      (data && !data.HasProjectedCounts && data.Phase === 0) ||
      (data && data.Phase === 1 && !data.HasProjectedCounts)
    ) {
      return false;
    }
    if (data && data.Phase > 1) {
      return true;
    }
    return true;
  };

  isProcessEnabled = () => {
    const { data } = this.props;

    if (data && data.IsClosed) {
      return false;
    }

    if (data && data.HasProjectedCounts && data.Phase === 0) {
      return false;
    }

    return true;
  };

  getMainProps = () => {
    const { loading } = this.props;
    return {
      toolbox: {
        formName: VERIFICATION_SELECTION_FORM_NAME,
        saveButtonProps: {
          content: 'Process',
          loading: loading,
          disabled: !this.isProcessEnabled(),
        },
        rightButtons: [
          {
            loading: loading,
            content: 'Start over',
            onClick: () => this.setState({ showYesNo: true }),
            disabled: !this.isStartOverEnabled(),
          },
        ],
        shown: true,
      },
    };
  };

  render() {
    const { fiscalYear, data } = this.props;
    let isBetweenDates = false;
    if (this.props.loading) {
      return <LoadingPage />;
    }

    if (data !== null && !!fiscalYear) {
      const asOfDate = data.AsOfDate.substring(0, 10);

      isBetweenDates = moment().isBetween(
        asOfDate,
        `${fiscalYear}-07-01`,
        null,
        '[)'
      );
    }

    return (
      <div>
        <Filter
          title={
            isBetweenDates
              ? 'Verification Selection'
              : 'Verification Selection - Projected'
          }
        />
        <Main {...this.getMainProps()}>
          <VerificationSelectionForm
            onSubmit={this.handleProcess}
            initialValues={this.props.data}
            phase={this.props.data ? this.props.data.Phase : null}
            userMessage={this.props.data ? this.props.data.UserMessage : null}
            isClosed={this.props.data ? this.props.data.IsClosed : null}
          />
          <YesNoDialog
            title={'Are you sure you would like to start over?'}
            showDialog={this.state.showYesNo}
            noCallback={() => {
              this.setState({ showYesNo: false });
            }}
            yesCallback={this.handleStartOver}
          />
        </Main>
      </div>
    );
  }
}
const mapStateToProps = (state, ownProps) => {
  ownProps.setPageLevelDirty(getIsDirty()(state));
  return {
    data: selector.getData(state),
    result: selector.getResult(state),
    loading: selector.getLoading(state),
    fiscalYear: fiscalYear(state),
  };
};

export const VerificationSelection = withRouter(
  connect(
    mapStateToProps,
    {
      fetchData,
      processVerification,
      clearProcessResult,
      startOver,
      getControlInfo,
    }
  )(VerificationSelectionContainer)
);



// WEBPACK FOOTER //
// ./src/pages/verificationselection/VerificationSelection.js